/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import {
  MdOutlineArrowForward,
  MdOutlineCalendarMonth,
  MdFlightTakeoff,
} from 'react-icons/md';
import isAfter from 'date-fns/isAfter';
import isSameDay from 'date-fns/isSameDay';
import './ManageBookingPage.scss';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import {
  getCancellationPolicyApi,
  getFlightTicketApi,
  rescheduleSearchFlightsApi,
} from '../../api/flightApi';
import {
  NAVIGATION_ROUTES,
  ONLY_DATE_FORMAT,
  MONTH_YEAR_FORMAT,
  API_DATE_FORMAT,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  STATUS,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import AppModal from '../../shared/components/app-modal/AppModal';
import {
  formatDate,
  formatTimeString,
  getNewDate,
  hideHeaderMenu,
  isEmpty,
  showHeaderMenu,
} from '../../shared/helper-utils/appUtils';
import AppButton from '../../shared/components/app-button/AppButton';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import './FlightReshedulePage.scss';
import AppLoading from '../../shared/components/app-loading/AppLoading';

function ManageBookingPage() {
  const { transactionId } = useParams();
  const navigate = useNavigate();
  const hasApiProcessingRef = useRef(false);
  const flightTransactionRef = useRef(undefined);
  const flightRecordRef = useRef(null);
  const flightSectorsRef = useRef(null);
  const passengerRef = useRef(null);
  const fareSummaryRef = useRef(null);
  const bookingInfoRef = useRef({});
  const [apiError, setApiError] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);
  const taxNodesRef = useRef(undefined);
  const rescheduleSearchParamRef = useRef({
    origin: '',
    destination: '',
    jdate: '',
    rdate: '',
    jtype: '',
    carrier: '',
    numadults: 1,
    numchildren: 0,
    numinfants: 0,
  });
  const reschedulePaxDetails = useRef([]);
  const [changeBookingSector, setChangeBookingSector] = useState([]);

  // useEffect(() => {
  //   hideHeaderMenu();
  //   return () => showHeaderMenu();
  // }, []);

  const setFareSummary = (invoice) => {
    const { FlightApiPricingLog } = invoice.FlightApiPricingLogs;
    if (FlightApiPricingLog?.ResponseXml) {
      const { FullBreakup } = FlightApiPricingLog.ResponseXml;
      let taxNodes = [];
      if (FullBreakup?.TotalBreakup) {
        taxNodes = Array.isArray(FullBreakup.TotalBreakup.TaxNode)
          ? FullBreakup.TotalBreakup.TaxNode
          : [FullBreakup.TotalBreakup.TaxNode];
      } else {
        taxNodes = Array.isArray(FullBreakup?.AdultBreakup.TaxNode)
          ? FullBreakup.AdultBreakup.TaxNode
          : [FullBreakup.AdultBreakup.TaxNode];
      }
      taxNodesRef.current = taxNodes;
      fareSummaryRef.current = {
        adultBaseFare: FullBreakup.AdultBase,
        childBaseFare: FullBreakup.ChildBase,
        infantBaseFare: FullBreakup.InfantBase + FullBreakup.InfantTax,
        totalFare: 0,
      };
    } else {
      fareSummaryRef.current = {
        adultBaseFare: 0,
        childBaseFare: 0,
        infantBaseFare: 0,
        totalFare: 0,
      };
    }

    let { PassengerSSRRecord } = invoice.PassengerSSRRecords;
    if (PassengerSSRRecord !== undefined && PassengerSSRRecord !== '') {
      PassengerSSRRecord = Array.isArray(PassengerSSRRecord)
        ? PassengerSSRRecord
        : [PassengerSSRRecord];
    } else {
      PassengerSSRRecord = [];
    }

    let seatPrice = 0;
    let mealPrice = 0;
    let baggagePrice = 0;
    let specialSsrPrice = 0;
    let hasSeat = false;
    let hasMeal = false;
    let hasBaggage = false;
    let hasSpecialSsr = false;
    PassengerSSRRecord.forEach((record) => {
      if (record.SSRType.toLowerCase() === 'seat') {
        seatPrice += parseInt(record.ChargeableAmount, 10);
        hasSeat = true;
      }
      if (record.SSRType.toLowerCase() === 'meal') {
        mealPrice += parseInt(record.ChargeableAmount, 10);
        hasMeal = true;
      }
      if (record.SSRType.toLowerCase() === 'baggage') {
        baggagePrice += parseInt(record.ChargeableAmount, 10);
        hasBaggage = true;
      }
      if (record.SSRType.toLowerCase() === 'specialssr') {
        specialSsrPrice += parseInt(record.ChargeableAmount, 10);
        hasSpecialSsr = true;
      }
    });

    fareSummaryRef.current.hasSeat = hasSeat;
    fareSummaryRef.current.hasMeal = hasMeal;
    fareSummaryRef.current.hasBaggage = hasBaggage;
    fareSummaryRef.current.hasSpecialSsr = hasSpecialSsr;
    fareSummaryRef.current.seatPrice = seatPrice;
    fareSummaryRef.current.mealPrice = mealPrice;
    fareSummaryRef.current.baggagePrice = baggagePrice;
    fareSummaryRef.current.specialSsrPrice = specialSsrPrice;
    const adultTotal = invoice.FlightRecord.FareDetails.split('##')[0];
    // const GSTDifference = taxNodes.find(
    //   (tx) => tx !== undefined && tx.TaxName === 'GSTDifference',
    // );
    // taxNodes.forEach((tx) => {
    //   if (tx !== undefined && tx.TaxName === 'GST') {
    //     tx.TaxValue += GSTDifference ? GSTDifference.TaxValue : 0;
    //   }
    // });
    const gstDiff = 0;
    // if (GSTDifference) {
    //   gstDiff = GSTDifference.TaxValue;
    // }
    fareSummaryRef.current.totalFare +=
      adultTotal +
      seatPrice +
      mealPrice +
      baggagePrice +
      specialSsrPrice +
      gstDiff;
  };

  const getData = async () => {
    if (!hasApiProcessingRef.current) {
      setIsLoading(true);
      const response = await getFlightTicketApi(
        transactionId,
        getUserAgentId(),
      );
      if (
        response &&
        response.ApiStatus &&
        response.ApiStatus.Status === 'OK'
      ) {
        const { FlightInvoice } = response.ApiStatus.Result.FullFlightDetails;
        flightTransactionRef.current = FlightInvoice;
        flightRecordRef.current = FlightInvoice.FlightRecord;
        bookingInfoRef.current = {
          AirlinePnr: FlightInvoice.FlightRecord.AirlinePnr,
          BookingStatus: FlightInvoice.FlightRecord.BookingStatus,
          Origin: FlightInvoice.FlightRecord.Origin,
          Destination: FlightInvoice.FlightRecord.Destination,
          Jtype: FlightInvoice.FlightRecord.JType.toLowerCase(),
        };
        rescheduleSearchParamRef.current = {
          origin: FlightInvoice.FlightRecord.Origin,
          destination: FlightInvoice.FlightRecord.Destination,
          jdate: FlightInvoice.FlightRecord.JDate,
          rdate:
            FlightInvoice.FlightRecord.JType === 'OneWay'
              ? ''
              : FlightInvoice.FlightRecord.RDate,
          jtype: FlightInvoice.FlightRecord.JType.toLowerCase(),
          carrier: FlightInvoice.FlightRecord.Carrier,
          numadults: FlightInvoice.FlightRecord.NumAdults,
          numchildren: FlightInvoice.FlightRecord.NumChildren,
          numinfants: FlightInvoice.FlightRecord.NumInfants,
          airlinePNR: FlightInvoice.FlightRecord.AirlinePnr,
        };
        let { SectorRecord } = FlightInvoice.SectorRecords;
        SectorRecord = Array.isArray(SectorRecord)
          ? SectorRecord
          : [SectorRecord];
        const airportNames = {};
        SectorRecord.forEach((ele) => {
          airportNames[ele.Origin] = ele.OriginFullName;
          airportNames[ele.Destination] = ele.DestinationFullName;
        });
        const changeBookingArr = [];
        if (FlightInvoice.FlightRecord.JType === 'OneWay') {
          changeBookingArr.push({
            Origin: FlightInvoice.FlightRecord.Origin,
            OriginFullName: airportNames[FlightInvoice.FlightRecord.Origin],
            Destination: FlightInvoice.FlightRecord.Destination,
            DestinationFullName:
              airportNames[FlightInvoice.FlightRecord.Destination],
            JourneyDate: FlightInvoice.FlightRecord.JDate,
            flightType: 'Onward',
            checked: false,
            selectedDate: '',
          });
        } else {
          changeBookingArr.push({
            Origin: FlightInvoice.FlightRecord.Origin,
            OriginFullName: airportNames[FlightInvoice.FlightRecord.Origin],
            Destination: FlightInvoice.FlightRecord.Destination,
            DestinationFullName:
              airportNames[FlightInvoice.FlightRecord.Destination],
            JourneyDate: FlightInvoice.FlightRecord.JDate,
            flightType: 'Onward',
            checked: false,
            selectedDate: '',
          });
          changeBookingArr.push({
            Origin: FlightInvoice.FlightRecord.Destination,
            OriginFullName:
              airportNames[FlightInvoice.FlightRecord.Destination],
            Destination: FlightInvoice.FlightRecord.Origin,
            DestinationFullName:
              airportNames[FlightInvoice.FlightRecord.Origin],
            JourneyDate: FlightInvoice.FlightRecord.RDate,
            flightType: 'Return',
            checked: false,
            selectedDate: '',
          });
        }
        flightSectorsRef.current = SectorRecord;
        let { PassengerSSRRecord } = FlightInvoice.PassengerSSRRecords;
        if (PassengerSSRRecord !== undefined && PassengerSSRRecord !== '') {
          PassengerSSRRecord = Array.isArray(PassengerSSRRecord)
            ? PassengerSSRRecord
            : [PassengerSSRRecord];
        } else {
          PassengerSSRRecord = [];
        }
        let { PassengerRecord } = FlightInvoice.PassengerRecords;
        PassengerRecord = Array.isArray(PassengerRecord)
          ? PassengerRecord
          : [PassengerRecord];
        passengerRef.current = {};
        const passengersBySegmentNumber = PassengerRecord.reduce((acc, cur) => {
          if (acc[cur.SegmentNumber]) {
            acc[cur.SegmentNumber].push(cur);
          } else {
            acc[cur.SegmentNumber] = [cur];
          }
          reschedulePaxDetails.current.push({
            paxid: cur.Paxid,
            tripnumber: cur.SegmentNumber,
          });
          return acc;
        }, {});

        const ssrRecordsByTripNumber = PassengerSSRRecord.reduce((acc, cur) => {
          if (acc[cur.TripNumber]) {
            acc[cur.TripNumber].push(cur);
          } else {
            acc[cur.TripNumber] = [cur];
          }
          return acc;
        }, {});

        Object.keys(ssrRecordsByTripNumber).forEach((tripNumber) => {
          const ssrBySector = ssrRecordsByTripNumber[tripNumber].reduce(
            (acc, cur) => {
              const sector = `${cur.Origin} - ${cur.Destination}`;
              if (acc[sector]) {
                acc[sector].push(cur);
              } else {
                acc[sector] = [cur];
              }
              return acc;
            },
            {},
          );
          ssrRecordsByTripNumber[tripNumber] = ssrBySector;
        });
        flightSectorsRef.current.forEach((sectorRecord) => {
          const sector = `${sectorRecord.Origin} - ${sectorRecord.Destination}`;
          let tripNumber = 1;
          if (sectorRecord.FlightType.toLowerCase() === 'return') {
            tripNumber = 2;
          }
          const passengers = passengersBySegmentNumber[tripNumber];
          if (ssrRecordsByTripNumber[tripNumber]) {
            const ssrRecords = ssrRecordsByTripNumber[tripNumber][sector];
            if (ssrRecords) {
              passengers.forEach((passenger) => {
                const ssrRecord = ssrRecords.filter(
                  (ssr) => ssr.Paxid === passenger.Paxid,
                );
                passenger.ssrRecord = ssrRecord;
              });
            }
          }
          passengerRef.current[sector] = passengers;
        });
        const paxList = [];
        Object.keys(passengerRef.current).forEach((sec) => {
          passengerRef.current[sec].forEach((pax) => {
            if (paxList[sec] === undefined) {
              paxList[sec] = [];
            }
            paxList.push({
              fullname: `${pax.Title} ${pax.FirstName} ${pax.LastName}`,
              paxid: pax.Paxid,
              tripnumber: pax.SegmentNumber,
              isSelected: true,
              status: pax.Status,
              visa: pax.Visa,
              paxtype: pax.Type,
              disabled: pax.Type === 'infant',
              additionalSegmentInfo: pax.AdditionalSegmentInfo,
            });
          });
        });
        if (FlightInvoice.FlightRecord.JType === 'OneWay') {
          changeBookingArr[0].passengers = [
            ...new Map(paxList.map((item) => [item.paxid, item])).values(),
          ];
        } else {
          const onwardPax = paxList.filter((p) => p.tripnumber === 1);
          const returnPax = paxList.filter((p) => p.tripnumber === 2);
          changeBookingArr[0].passengers = [
            ...new Map(onwardPax.map((item) => [item.paxid, item])).values(),
          ];
          changeBookingArr[1].passengers = [
            ...new Map(returnPax.map((item) => [item.paxid, item])).values(),
          ];
        }
        setChangeBookingSector(changeBookingArr);
        setFareSummary(FlightInvoice);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    getData();
    hasApiProcessingRef.current = true;
  }, [transactionId]);

  const handleCheckboxSelection = (event, sectorIndex) => {
    const { checked } = event.target;
    const obj = [...changeBookingSector];
    obj[sectorIndex].checked = checked;
    setChangeBookingSector(obj);
  };

  const handleRescheduleDateChange = (dateOrEvent, sectorIndex) => {
    let formattedDate = '';
    if (dateOrEvent?.target) {
      formattedDate = dateOrEvent.target.value || '';
    } else if (dateOrEvent) {
      formattedDate = formatDate(getNewDate(dateOrEvent), API_DATE_FORMAT);
    }
    const obj = [...changeBookingSector];
    obj[sectorIndex].selectedDate = formattedDate;
    setChangeBookingSector(obj);
  };

  const isChangeBookingButtonDisabled = () => {
    const isDisabled = changeBookingSector.some(
      (sector) => sector.checked === true && sector.selectedDate !== '',
    );
    let isAtleastOnePaxSelected = true;
    changeBookingSector.forEach((sector) => {
      if (
        sector.checked &&
        sector.selectedDate !== '' &&
        sector.selectedDate !== undefined
      ) {
        const list = sector.passengers.filter((pax) => pax.isSelected);
        isAtleastOnePaxSelected = list.length > 0;
      }
    });
    return !isDisabled || !isAtleastOnePaxSelected;
  };

  const handleChangeBooking = () => {
    setOpenConfirmPopup(true);
  };

  const handleConfirmChangeBooking = async () => {
    setOpenConfirmPopup(false);
    // if (
    //   changeBookingSector.filter((x) => isEmpty(x.selectedDate) === true)
    //     .length > 0
    // ) {
    //   setApiError({
    //     title: 'Reschedule Booking',
    //     variant: 'error',
    //     description:
    //       'Parial Reschedule is not available, please do complete reschedule',
    //   });
    //   return false;
    // }

    setIsLoading(true);
    const agentId = getUserAgentId();
    const paxList = [];
    let numAdults = 0;
    let numChild = 0;
    let numInfant = 0;
    let isOnward = false;
    let isRoundTrip = false;
    rescheduleSearchParamRef.current.jdate = '';
    rescheduleSearchParamRef.current.rdate = '';
    changeBookingSector.forEach((sector) => {
      if (sector.flightType === 'Onward') {
        if (sector.selectedDate !== '' && sector.selectedDate !== undefined) {
          rescheduleSearchParamRef.current.jdate =
            sector.selectedDate.replaceAll('-', '');
          isOnward = true;
          const list = sector.passengers.filter((pax) => pax.isSelected);
          list.forEach((ele) => {
            if (ele.paxtype === 'infant') {
              numInfant += 1;
            } else if (ele.paxtype === 'adult') {
              numAdults += 1;
            } else if (ele.paxtype === 'child') {
              numChild += 1;
            }
            paxList.push({
              paxid: ele.paxid,
              tripnumber: ele.tripnumber,
            });
          });
        }
      } else if (
        sector.selectedDate !== '' &&
        sector.selectedDate !== undefined
      ) {
        if (isOnward === false) {
          const list = sector.passengers.filter((pax) => pax.isSelected);
          list.forEach((ele) => {
            if (ele.paxtype === 'infant') {
              numInfant += 1;
            } else if (ele.paxtype === 'adult') {
              numAdults += 1;
            } else if (ele.paxtype === 'child') {
              numChild += 1;
            }
            paxList.push({
              paxid: ele.paxid,
              tripnumber: ele.tripnumber,
            });
          });
          rescheduleSearchParamRef.current.jdate =
            sector.selectedDate.replaceAll('-', '');
          rescheduleSearchParamRef.current.origin = sector.Origin;
          rescheduleSearchParamRef.current.destination = sector.Destination;
        } else {
          rescheduleSearchParamRef.current.rdate =
            sector.selectedDate.replaceAll('-', '');
          isRoundTrip = true;
          const list = sector.passengers.filter((pax) => pax.isSelected);
          list.forEach((ele) => {
            paxList.push({
              paxid: ele.paxid,
              tripnumber: ele.tripnumber,
            });
          });
        }
      }
    });

    rescheduleSearchParamRef.current.numadults = numAdults;
    rescheduleSearchParamRef.current.numchildren = numChild;
    rescheduleSearchParamRef.current.numinfants = numInfant;
    rescheduleSearchParamRef.current.jtype =
      isOnward && isRoundTrip ? 'roundtrip' : 'oneway';
    const searchResponse = await rescheduleSearchFlightsApi(
      paxList,
      rescheduleSearchParamRef.current,
      agentId,
      transactionId,
      reschedulePaxDetails.current.length === paxList.length
        ? 'full'
        : 'partial',
    );
    setIsLoading(false);
    if (searchResponse && searchResponse.statuscode === '200') {
      let rescheduleResultsRoute = '';
      if (rescheduleSearchParamRef.current.jtype === 'roundtrip') {
        rescheduleResultsRoute =
          NAVIGATION_ROUTES.CHANGE_BOOKING.RESCHEDULE_ROUNDTRIP_RESULTS.replace(
            ':transactionId',
            transactionId,
          );
      } else {
        rescheduleResultsRoute =
          NAVIGATION_ROUTES.CHANGE_BOOKING.RESCHEDULE_RESULTS.replace(
            ':transactionId',
            transactionId,
          );
      }
      rescheduleSearchParamRef.current.jdate = `${rescheduleSearchParamRef.current.jdate.substring(
        0,
        3,
      )}-${rescheduleSearchParamRef.current.jdate.substring(
        4,
        6,
      )}-${rescheduleSearchParamRef.current.jdate.substring(6, 8)}`;
      navigate(rescheduleResultsRoute, {
        state: {
          searchRequest: rescheduleSearchParamRef.current,
          searchResponse,
          changeBookingSector,
          transactionId,
          airlinePNR: rescheduleSearchParamRef.current.airlinePNR,
        },
      });
    } else {
      setApiError({
        title: 'Search Results',
        description: 'No flights found for the given date',
      });
    }
  };

  const getFlightTicketRoute = (txid) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE;
    route = route.replace(':transactionId', txid);
    return route;
  };

  return (
    <section className="manage-booking-page">
      {apiError && (
        <AppAlert
          title={apiError.title}
          description={apiError.description}
          variant="error"
          showIcon={false}
          onHide={() => setApiError(undefined)}
        />
      )}
      <AppLoading isLoading={isLoading} />
      <section className="app-container flight-reshedule-page_container">
        {flightRecordRef.current !== null && (
          <div className="flight-details">
            <h4>Flight Details</h4>
            <div className="flight-details-table overflow-auto">
              <table cellSpacing="4" cellPadding="5" className="w-100">
                <tbody>
                  <tr>
                    <td>Airline PNR</td>
                    <td>{flightRecordRef.current.AirlinePnr.split(',')[0]}</td>
                    <td>Booking Date</td>
                    <td>{flightRecordRef.current.BookingDate}</td>
                  </tr>
                  <tr>
                    <td>Booking Id</td>
                    <td>
                      <a
                        href={getFlightTicketRoute(
                          flightRecordRef.current.Txid,
                        )}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {flightRecordRef.current.Txid}
                      </a>
                    </td>
                    <td>Passenger Contact</td>
                    <td>{flightRecordRef.current.PassengerContact}</td>
                  </tr>
                  <tr>
                    <td>Booking Status</td>
                    <td>{flightRecordRef.current.BookingStatus}</td>
                    <td colSpan={2} />
                  </tr>
                </tbody>
              </table>
              <table className="w-100">
                <thead>
                  <tr>
                    <th>From - To</th>
                    <th>Flight</th>
                    <th>Departure Date</th>
                    <th>Departure</th>
                    <th>Arrival</th>
                  </tr>
                </thead>
                <tbody>
                  {flightSectorsRef.current.map((sector, sectorIndex) => (
                    <React.Fragment
                      key={`${sector.Origin}:${sector.Destination}`}
                    >
                      <tr>
                        <td>
                          {sector.OriginFullName}({sector.Origin}) --&gt;{' '}
                          {sector.DestinationFullName}({sector.Destination})
                        </td>
                        <td>
                          {sector.OperatedBy} {sector.Carrier} -{' '}
                          {sector.FlightNumber}(class-{sector.BookingClass})
                        </td>
                        <td>
                          {formatDate(
                            getNewDate(sector.JourneyDate),
                            DATE_MONTH_YEAR_VIEW_FORMAT,
                          )}
                        </td>
                        <td>{formatTimeString(sector.DepartureTime)}</td>
                        <td>{formatTimeString(sector.ArrivalTime)}</td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
              <table className="w-100">
                <thead>
                  <tr>
                    <th>Tx.Id</th>
                    <th>Journey Type</th>
                    <th>Booking Date</th>
                    <th>GDS PNR</th>
                    <th>Agent ID</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{flightRecordRef.current.Txid}</td>
                    <td>{flightRecordRef.current.JType}</td>
                    <td>{flightRecordRef.current.BookingDate}</td>
                    <td>{flightRecordRef.current.GdsPnr}</td>
                    <td>{flightRecordRef.current.AgentId}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
        <div className="separator" />
        <section className="modify-booking-options-section">
          <div className="modify-booking-options-section__header">
            <div className="d-flex align-items-center gap-2">
              <MdFlightTakeoff className="section-header-icon" />
              <div>
                <h5 className="section-title m-0">
                  Select Sector to Reschedule
                </h5>
                <p className="section-subtitle m-0">
                  Choose the flight sector(s) you wish to reschedule and select
                  your new preferred travel date.
                </p>
              </div>
            </div>
          </div>

          <div className="modify-booking-options-section__body">
            <div className="reschedule-sectors-grid">
              {changeBookingSector.map((sector, sectorIndex) => {
                const sec = `${sector.Origin} - ${sector.Destination}`;
                const isSelected = Boolean(sector.checked);
                const flightType =
                  sector.flightType ||
                  (sectorIndex === 0 ? 'Onward' : 'Return');

                return (
                  <div
                    key={sectorIndex}
                    className={`reschedule-sector-card ${
                      isSelected ? 'reschedule-sector-card--selected' : ''
                    }`}
                  >
                    <div className="reschedule-sector-card__top">
                      <span
                        className={`sector-type-badge sector-type-badge--${flightType.toLowerCase()}`}
                      >
                        {flightType} Flight
                      </span>
                      <label
                        htmlFor={`sector-checkbox-${sectorIndex}`}
                        className="sector-checkbox-label"
                      >
                        <input
                          id={`sector-checkbox-${sectorIndex}`}
                          type="checkbox"
                          className="sector-checkbox-input"
                          name={sec}
                          checked={isSelected}
                          onChange={(event) =>
                            handleCheckboxSelection(event, sectorIndex)
                          }
                        />
                        <span className="sector-checkbox-text">
                          Reschedule Sector
                        </span>
                      </label>
                    </div>

                    <div className="reschedule-sector-card__details">
                      <div className="sector-date-badge">
                        <span className="sector-date-badge__day">
                          {formatDate(
                            getNewDate(sector.JourneyDate),
                            ONLY_DATE_FORMAT,
                          )}
                        </span>
                        <span className="sector-date-badge__month">
                          {formatDate(
                            getNewDate(sector.JourneyDate),
                            MONTH_YEAR_FORMAT,
                          )}
                        </span>
                      </div>

                      <div className="sector-route-details">
                        <div className="route-cities">
                          <span className="city-name origin">
                            {sector.OriginFullName === '-'
                              ? sector.Origin
                              : sector.OriginFullName}{' '}
                            <span className="airport-code">
                              ({sector.Origin})
                            </span>
                          </span>
                          <MdOutlineArrowForward className="route-arrow-icon" />
                          <span className="city-name destination">
                            {sector.DestinationFullName === '-'
                              ? sector.Destination
                              : sector.DestinationFullName}{' '}
                            <span className="airport-code">
                              ({sector.Destination})
                            </span>
                          </span>
                        </div>
                        <div className="current-travel-date">
                          <span className="label">Current Date:</span>{' '}
                          <span className="value">
                            {formatDate(
                              getNewDate(sector.JourneyDate),
                              DATE_MONTH_YEAR_VIEW_FORMAT,
                            )}
                          </span>
                        </div>
                      </div>
                    </div>

                    {isSelected && (
                      <div className="reschedule-sector-card__datepicker-container">
                        <div className="datepicker-header-row">
                          <div className="d-flex align-items-center gap-1">
                            <MdOutlineCalendarMonth className="calendar-icon" />
                            <span className="datepicker-title">
                              Preferred New Date
                            </span>
                          </div>
                          <span className="required-indicator">* Required</span>
                        </div>
                        <div className="datepicker-input-wrapper">
                          <AppDatePicker
                            label=""
                            placeholder="Select Preferred Date"
                            name={sec}
                            className="app-date-picker"
                            customClassName="reschedule-datepicker-input"
                            minDate={getNewDate(TODAY_DATE)}
                            selectedDate={
                              !isEmpty(sector.selectedDate)
                                ? getNewDate(sector.selectedDate)
                                : null
                            }
                            onChange={(date) =>
                              handleRescheduleDateChange(date, sectorIndex)
                            }
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            disabledKeyboardNavigation
                          />
                        </div>
                        {isEmpty(sector.selectedDate) ? (
                          <div className="datepicker-status-hint datepicker-status-hint--pending">
                            Please select a new date for this sector
                          </div>
                        ) : (
                          <div className="datepicker-status-hint datepicker-status-hint--selected">
                            Selected Date:{' '}
                            {formatDate(
                              getNewDate(sector.selectedDate),
                              DATE_MONTH_YEAR_VIEW_FORMAT,
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="modify-booking-options-section__footer">
            <AppButton
              disabled={isChangeBookingButtonDisabled()}
              btnText="Reschedule Booking"
              onClick={handleChangeBooking}
              className="reschedule-submit-btn"
            />
          </div>
        </section>
      </section>
      {openConfirmPopup && (
        <Modal
          backdrop="static"
          keyboard={false}
          className="app-modal"
          show
          onHide={setOpenConfirmPopup}
        >
          <Modal.Header closeButton={false}>
            <Modal.Title>Are you sure?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Selected passengers would be split from original PNR and then new
            PNR would be generated upon successful Reissue. Would you like to
            continue?
          </Modal.Body>
          <Modal.Footer>
            <AppButton
              variant="secondary"
              onClick={() => setOpenConfirmPopup(false)}
              btnText="Cancel"
            />
            <AppButton
              variant="primary"
              onClick={handleConfirmChangeBooking}
              btnText="Confirm"
            />
          </Modal.Footer>
        </Modal>
      )}
    </section>
  );
}

export default ManageBookingPage;
